import { useEffect, useRef } from "react";

// Premium custom cursor with a trailing ring that grows over interactive elements.
export default function CustomCursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    let rx = 0, ry = 0, mx = 0, my = 0, raf;

    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dot.current) dot.current.style.transform = `translate(${mx}px, ${my}px) translate(-50%,-50%)`;
    };
    const loop = () => {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%,-50%)`;
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => {
      if (e.target.closest("a,button,[data-cursor='hover'],input,select,textarea")) {
        ring.current?.style.setProperty("width", "56px");
        ring.current?.style.setProperty("height", "56px");
        ring.current?.style.setProperty("background", "color-mix(in srgb, var(--brand) 15%, transparent)");
      } else {
        ring.current?.style.setProperty("width", "34px");
        ring.current?.style.setProperty("height", "34px");
        ring.current?.style.setProperty("background", "transparent");
      }
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dot} className="cursor-dot" />
      <div ref={ring} className="cursor-ring" />
    </>
  );
}
